<template>
  <iRow>
    <UrlElement
      v-for="hashtag in hashtags"
      :key="hashtag.hashtag_id"
      v-bind="$props"
      :href="getHashtagPageUrl(hashtag)"
    >
      #{{ hashtag.hashtag }}
    </UrlElement>
  </iRow>
</template>

<script>
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";
import HashtagClickBehavior from "%/dynamic-component-editor/options/hashtag-click-behavior";

export default {
  name: "HashTags",
  elementPanelSettings: {
    displayIcon: "hashtag",
    displayName: "Hashtags",
  },
  components: { UrlElement },
  extends: UrlElement,
  mixins: [StoryPageElementMixin],
  options: [HashtagClickBehavior],
  computed: {
    hashtags() {
      return this.entity.hashtags;
    },
    publicationBaseUrl() {
      return useGeneralStore().getLink("web");
    },
    label() {
      return "hashtags";
    },
  },
  methods: {
    getHashtagPageUrl(hashtag) {
      return HashtagClickBehavior.hashtagHref(
        this.publicationBaseUrl,
        {
          authorProfile: this.entity.authoringUserId,
          postPage: this.entity.storyId,
          hashtagPage: hashtag.hashtag,
        },
        this.getOptionValue(HashtagClickBehavior),
      );
    },
  },
};
</script>
